import { createAsyncSliceWithData } from '../../createAsyncSliceWithData';
import { getEscrowBankAccountsAsync } from '../../../API/accounting/getEscrowBankAccountsAsync';

export const { slice: bankAccountListSlice, asyncAction: loadBankAccountList } = createAsyncSliceWithData(
  'bankAccountListSlice',
  getEscrowBankAccountsAsync,
  []
);
